import { render, staticRenderFns } from "./AddEventPage.vue?vue&type=template&id=90aa5214&scoped=true&"
import script from "./AddEventPage.vue?vue&type=script&lang=js&"
export * from "./AddEventPage.vue?vue&type=script&lang=js&"
import style0 from "./AddEventPage.vue?vue&type=style&index=0&id=90aa5214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90aa5214",
  null
  
)

export default component.exports